<template>
    <div class="input-units">
        <input type="text"
               class="form-control"
               :placeholder="placeholderValue"
               v-model="searchTerm"
               v-on:keyup="onSearchTermChanged" v-on:focus="onFocusChanged(true)" v-on:blur="onFocusChanged(false)">
        <span class="units"><b-icon icon="search"/></span>
    </div>
</template>

<script>
    export default {
        name: "DataTableSearch",
        props: {
            placeholder: { type: String, default: null },
            initialValue: { type: String, default: '' },
        },
        data() {
            return {
                searchTerm: ''
            }
        },
        computed: {
            placeholderValue() {
                return this.placeholder && this.placeholder.length ? this.placeholder : 'Поиск'
            }
        },
        methods: {
            onSearchTermChanged(e) {
                this.$emit('search-term-changed', this.searchTerm);
            },
            onFocusChanged(focused) {
                this.$emit('search-focus-changed', focused);
            },
        },
        mounted() {
            this.searchTerm = this.initialValue
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";


    .input-units {
        position: relative;

        & input.form-control.is-valid {
            background-image: none;
            padding-right: 0;
        }

        & .units {
            position:absolute;
            background-color: $input-bg;
            color: $secondary;
            width:32px;
            height: calc(100% - 2px);
            top: 1px;
            right: 5px;
            padding-top:6px;
            padding-left: 7px;
        }
    }
</style>